import { Link } from 'react-router-dom'
import { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useLocation } from 'react-use'
import _ from 'lodash'
import classNames from 'classnames'

import Button from 'components/Button'
import { Body } from 'layouts/basic'
import Input from 'components/Forms/Input'
import useAuthStore from 'store/auth'

import { errorMessages, validPasswordLength, validEmail } from 'components/Forms/Input/validate'


export default function Login(props) {
  const history = useHistory()
  const { search } = useLocation()
  const query = new URLSearchParams(search)
  const redirect = query.get('redirect') || '/'
  const { login, getUser } = useAuthStore()
  const [errors, setErrors] = useState(false)
  const [sendingForm, setSendingForm] = useState(false)

  const validateForm = (data) => {
    const passwordValid = validPasswordLength(data.password)
    const emailValid = validEmail(data.email)
    let errorsList = {}
    let isValidForm = true

    if (!emailValid) {
      errorsList['/data/attributes/email'] = errorMessages.validEmail
      isValidForm = false
    }
    if (!passwordValid) {
      errorsList['/data/attributes/password'] = errorMessages.validPasswordLength
      isValidForm = false
    }

    if (Object.keys(errorsList).length) {
      setErrors(errorsList)
    }

    return isValidForm

  }

  const onSubmit = async e => {
    e.preventDefault()
    setSendingForm(true)
    const email = e.currentTarget.elements[0].value
    const password = e.currentTarget.elements[1].value
    const isValidForm = validateForm({ email, password })
    if (isValidForm) {
      const response = await login(email, password)
      if (response.errors) {
        setErrors(
          _.reduce(
            _.get(response, 'errors', [{ detail: 'Error' }]),
            (red, item) => ({ ...red, [item.source.pointer]: item.detail }),
            {},
          )
        )
      } else {
        const accessToken = response.data.access
        const refreshAccessToken = response.data.refresh

        localStorage.setItem('improvisaToken', accessToken)
        localStorage.setItem('improvisaRefreshToken', refreshAccessToken)

        await getUser()
        history.push(redirect)
      }
    }
    setSendingForm(false)
  }

  const emailHasError = errors && '/data/attributes/email' in errors
  const passwordHasError = errors && '/data/attributes/password' in errors
  const dataHasError = errors && '/data' in errors
  return (
    <Body>
      <div className='flex max-w-sm m-auto prose-sm lg:prose-xl'>
        <form onSubmit={onSubmit} className='text-center w-full'>
          <img src='/logo_improvisa192.png' alt='Improvisa' className='m-auto' />
          {
            emailHasError && (
              <span className='flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1'>
                {errors['/data/attributes/email']}
              </span>
            )
          }
          <Input
            inputProps={{
              required: true,
              type: 'email',
              placeholder: 'Email',
            }}
            className={classNames([
              { 'border border-red-500': emailHasError }
            ])}
          />
          {
            passwordHasError && (
              <span className='flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1'>
                {errors['/data/attributes/password']}
              </span>
            )
          }
          <Input
            inputProps={{
              type: 'password',
              required: true,
              placeholder: 'Password',
            }}
            className={classNames([
            { 'border border-red-500': passwordHasError }
          ])} />
          {
            dataHasError && (
              <span className='flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1'>
                {errors['/data']}
              </span>
            )
          }
          <Button type='submit' loading={sendingForm} disabled={sendingForm} className={classNames([
            'w-full text-base inverted',
          ])} >
            Login
          </Button>
          <div>
            <Link to='/recover-password' className='mt-4 text-blue-700 text-sm inline-flex items-center font-normal tracking-wide'>
              <span className="hover:underline">
                Forgot password?
              </span>
            </Link>
          </div>
          <div>
            <Link to='/signup' className='mt-8 text-blue-700 text-base inline-flex items-center font-semibold tracking-wide'>
              <span className="hover:underline">
                Don't have an account? Sign up
              </span>
              <span className="text-xl ml-2">&#8594;</span>
            </Link>
          </div>
        </form>
      </div>
    </Body>
  )
}
